/*
 * @Author: Liu xing wang
 * @Date: 2019-11-13 13:51:52
 */
/*
 * 表格弹出框title枚举
 * @author miqiang
 * @date 2019-11-13
 */
export enum TableAssemblyEnum {
    DEPT = '院系信息',
    NJXX = '年级信息',
    BXZY = '办学专业',
    XZB = '行政班',
    TEACHER = '教师',
    STUDENT = '学生',
    KCXX = '课程',
    JSXXLX = '教室类型',
    ROOM = '教室',
    JXBXX = '教学班',
    EXAMCLASS = '考试班',
    JSZ = '教室组',
    USER = '用户信息',
    RKJS = '任课教师',
    ROLE="角色信息"
}
